import TransitionService from 'edge/platform/widgets/accordion/transition/TransitionService';

export default angular.module('edge.platform.widgets.ui.bootstrap.transition', [])
    .factory('$gwPlTransition', TransitionService);